import { BFScreen } from "@/components/standard/screen/BFScreen"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { BFBackButton } from "@/components/standard/BFBackButton"
import { H5, H6, Small } from "@/components/standard/BFText"
import { type ReactNode, useState } from "react"
import { Pressable, ScrollView, View } from "react-native"
import {
  BFButton,
  type CommonButtonProps,
} from "@/components/buttons/CommonButtons"
import { SetupHeader } from "@/screens/loans/components/setup/SetupHeader"
import { router } from "expo-router"
import { useSafeAreaInsets } from "react-native-safe-area-context"

export const LoanSetupScreen = ({
  title,
  subTitle,
  stepData,
  address,
  children,
  nextButtonProps,
  onSubmit,
  backButton,
}: {
  title: string
  subTitle: string
  stepData?: [number, number]
  address?: string
  children: ReactNode
  nextButtonProps?: Partial<CommonButtonProps>
  onSubmit?: () => Promise<void>
  backButton?: () => void
}) => {
  const [loading, setLoading] = useState(false)
  const { disabled, ...buttonProps } = nextButtonProps || {}
  const insets = useSafeAreaInsets()

  return (
    <BFScreen dark={true} gradientBackground={true} noBackButton={true}>
      <Vertical className={"flex-1 "}>
        <View style={{ height: insets.top }} />
        <Horizontal
          testID={"get-quote-header"}
          className={"w-full justify-between px-4 py-5 items-center z-10"}
        >
          {backButton ? (
            <BFBackButton onBack={backButton} />
          ) : (
            <View className={"h-[23px] w-[30px]"} />
          )}
          <Vertical className={"items-center"}>
            <H5 color={"white"}>Get a Quote</H5>
            {address && <Small color={"white"}>{address}</Small>}
          </Vertical>
          <Pressable
            testID={"close-button"}
            hitSlop={32}
            onPress={() => {
              router.push("/loans")
            }}
          >
            <H6 color={"teal"}>Close</H6>
          </Pressable>
        </Horizontal>
        <View
          className={"flex-1 bg-off-white "}
          style={{ paddingBottom: insets.bottom }}
        >
          <ScrollView className={"flex-1"}>
            <SetupHeader
              title={title}
              subtitle={subTitle}
              stepData={stepData}
            />
            {children}
          </ScrollView>

          <View className={"p-5 border-t border-light-grey"}>
            <BFButton
              variant={"secondary"}
              testID={"next-button"}
              size={"lg"}
              title={"Close"}
              loading={loading}
              disabled={disabled || loading}
              {...buttonProps}
              onPress={() => {
                setLoading(true)
                void (async () => {
                  try {
                    await onSubmit?.()
                  } finally {
                    setLoading(false)
                  }
                })()
              }}
            />
          </View>
        </View>
      </Vertical>
    </BFScreen>
  )
}
